export default "__VITE_ASSET__DgYmgjdb__"